<!-- 企业级-业务领域-复核管理 -->
<template>
  <div class="mainArea CReview">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 搜索框 -->
        <div class="searchBox">
          <el-input class="w200" placeholder="入库单号" v-model="keyword.number" clearable></el-input>
          <el-select v-model="keyword.devices" placeholder="请选择设备" clearable>
            <el-option label="" value=""></el-option>
          </el-select>
          <el-select v-model="keyword.status" placeholder="请选择状态" clearable>
            <el-option label="" value=""></el-option>
          </el-select>
          <el-button class="searchBtn" type="primary">搜 索</el-button>
        </div>

        <el-table v-loading="loading" :data="bookData" style="width: 100%">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column label="入库单号" prop=""></el-table-column>
          <el-table-column label="入库人" prop=""></el-table-column>
          <el-table-column label="设备名称（库位）" prop=""></el-table-column>
          <el-table-column label="设备号" prop=""></el-table-column>
          <el-table-column label="入库时间" prop=""></el-table-column>
          <el-table-column label="复核人" prop=""></el-table-column>
          <el-table-column label="复核时间" prop=""></el-table-column>
          <el-table-column label="复核状态">
            <template slot-scope="scope">
              <span class="status1">未复核</span>
              <span class="status2">已复核</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text">复核</el-button>
              <!-- <el-button type="text">详情</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="paging" v-if="total>limits">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="limits"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
  </div>
</template>

<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../../static/js/utility/utility.js"

  export default {
    name: 'CReview',
    components: {
      CBreadCrumb,
    },
    data() {
      return {
        //搜索
        keyword:{
          number:'',//入库单号
          devices:'',//设备号
          status:'',//状态
        },

        loading:false,
        bookData:[],//仓库数据

        //分页
        curr:1,
        limits:10,
        total:0,

        wareDio:false,//弹窗
        dioTitle:'添加仓库',//弹窗标题
        dioform:{
          wareName:'',//仓库名称
          wareAddress:'',//仓库名称
        },

        rules:{
          wareName:[
            { required: true, message: '请输入仓库名称', trigger: 'blur' },
          ],
          wareAddress:[
            { required: true, message: '请输入仓库地址', trigger: 'blur' },
          ],
        },
      };
    },
    mounted(){

    },
    created: async function () {
      
    },
    methods: {
      //跳转到添加预约单
      toAddBook(){
        var navBarActive = [{function_tab: 'CAddBook', function_name: '添加预约单'}]
        // 更新面包屑内容
        updataBreadCrumb(4, navBarActive)
        this.$router.push({
          path:'/CAddBook'
        })
      },

      //弹窗确认
      submitWare(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            
          } else {
            return false;
          }
        });
      },

      //分页
      CurrentChange(val){
        this.curr = val
        //执行列表方法
      },
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.CReview{
  .w200{
    width: 200px;
  }
  .status1{
    color: #409EFF;
  }
  .status2{
    color: #67C23A;
  }
  .status3{
    color: #F56C6C;
  }
  .searchBox {
    margin-bottom: 20px;
    .searchInput {
      width: 300px;
    }
  }

  .addButton {
    margin-bottom: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CStorage/CReview/CReview.vue